import { useCallback, useEffect, useState } from 'react'
import pubsub from 'pubsub-js'
import { Alert, Button, Col, Row } from 'reactstrap'
import { getPendingOnboardingSurvey } from './onboardingSurveyApi'

const OnboardingSurveyDashboardPrompt = () => {
  const [hasPending, setHasPending] = useState(false)
  const [loading, setLoading] = useState(true)

  const runCheck = useCallback(async () => {
    if (!localStorage.getItem('token')) {
      setHasPending(false)
      setLoading(false)
      return
    }
    setLoading(true)
    try {
      const res = await getPendingOnboardingSurvey()
      const d = res.data?.data
      if (d && d.pending === true && d.formUrl) {
        setHasPending(true)
      } else {
        setHasPending(false)
      }
    } catch (e) {
      console.warn('OnboardingSurveyDashboardPrompt: check failed', e)
      setHasPending(false)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    runCheck()
  }, [runCheck])

  useEffect(() => {
    const refetch = () => {
      getPendingOnboardingSurvey()
        .then((res) => {
          const d = res.data?.data
          if (d && d.pending === true && d.formUrl) {
            setHasPending(true)
          } else {
            setHasPending(false)
          }
        })
        .catch(() => {
          setHasPending(false)
        })
    }
    const token = pubsub.subscribe('onboardingSurveyCompleted', refetch)
    return () => {
      pubsub.unsubscribe(token)
    }
  }, [])

  const openSurvey = () => {
    pubsub.publish('openOnboardingSurvey')
  }

  if (loading || !hasPending) {
    return null
  }

  return (
    <Row className='mb-3'>
      <Col xl={12}>
        <Alert color='info' className='d-flex flex-column flex-sm-row align-items-sm-center justify-content-between mb-0'>
          <span className='mb-2 mb-sm-0 pr-sm-2'>
            Keni një vlerësim onboarding të paplotësuar. Ju lutemi plotësojeni kur të keni mundësi.
          </span>
          <Button color='primary' onClick={openSurvey} className='text-nowrap'>
            Plotëso vlerësimin
          </Button>
        </Alert>
      </Col>
    </Row>
  )
}

export default OnboardingSurveyDashboardPrompt
